const CURRENCY_SYMBOLS = {
  USD: String.fromCharCode(36),
  GBP: String.fromCharCode(163),
  CAD: `CDN${String.fromCharCode(36)} `, // Space at the end is intentional
  EUR: String.fromCharCode(128),
};

const currencySymbol = currencyCode => CURRENCY_SYMBOLS[currencyCode] || String.fromCharCode(36);

const formatPrice = price => Number(price).toFixed(2);

export { currencySymbol, formatPrice };
